import { FormikErrors, FormikTouched, getIn } from 'formik';

import { ensureUnreachable } from 'src/utils/common_utils';

import { OnboardingLoginFormValues } from './OnboardingForms/onboardingFormTypes';

/**
 * This function is used to get the error text to display
 * @param errorsState formik errors state
 * @param touchedState formik errors state
 * @returns
 */
export function getFormErrorText<T = OnboardingLoginFormValues>(
  errorsState: FormikErrors<T>,
  touchedState: FormikTouched<T>,
) {
  const errorFieldKeys = Object.keys(errorsState);
  if (!errorFieldKeys.length) return '';

  return errorFieldKeys
    .reduce<string[]>((errorMessages, key) => {
      if (getIn(touchedState, key) && getIn(errorsState, key)) {
        const message: string = getIn(errorsState, key);
        errorMessages.push(message.replace('.', ''));
      }
      return errorMessages;
    }, [])
    .join(', ');
}

/**
 * Get the autoComplete attribute value for a given form field name.
 */
export function getAutoCompleteLabel(fieldName: 'email' | 'password'): string {
  switch (fieldName) {
    case 'email':
      return 'username';
    case 'password':
      return 'current-password';
    default:
      return ensureUnreachable(fieldName, `Unhandled field: ${fieldName}`);
  }
}
